import { render, staticRenderFns } from "./userAccessControl.vue?vue&type=template&id=6ae90e93&scoped=true&lang=en&"
import script from "./userAccessControl.vue?vue&type=script&lang=js&"
export * from "./userAccessControl.vue?vue&type=script&lang=js&"
import style0 from "./userAccessControl.vue?vue&type=style&index=0&id=6ae90e93&scoped=true&lang=css&"
import style1 from "./userAccessControl.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae90e93",
  null
  
)

export default component.exports